/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExperienceDayWaiter } from '../../models/experience-day-waiter';

export interface GetStudentExeperienceDayWaitlist$Params {
  profileId: string;
}

export function getStudentExeperienceDayWaitlist(http: HttpClient, rootUrl: string, params: GetStudentExeperienceDayWaitlist$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ExperienceDayWaiter>>> {
  const rb = new RequestBuilder(rootUrl, getStudentExeperienceDayWaitlist.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ExperienceDayWaiter>>;
    })
  );
}

getStudentExeperienceDayWaitlist.PATH = '/studentprofile/{profileId}/plannedexperienceday/waitlist';
